/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_TitleInputs */

const en_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortcut Keys`)
};

const fr_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis clavier`)
};

const de_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombinationen`)
};

const it_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasti di scelta rapida`)
};

const ru_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сочетания клавиш`)
};

const es_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de acceso directo`)
};

const zh_cn2_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷键`)
};

const ja_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートカットキー`)
};

const hi_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉर्टकट कुंजियाँ`)
};

const pt_pt2_shortcut_keys_title = /** @type {(inputs: Shortcut_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de atalho`)
};

/**
* | output |
* | --- |
* | "Shortcut Keys" |
*
* @param {Shortcut_Keys_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_title = /** @type {((inputs?: Shortcut_Keys_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_title(inputs)
	if (locale === "de") return de_shortcut_keys_title(inputs)
	if (locale === "it") return it_shortcut_keys_title(inputs)
	if (locale === "ru") return ru_shortcut_keys_title(inputs)
	if (locale === "es") return es_shortcut_keys_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_title(inputs)
	if (locale === "ja") return ja_shortcut_keys_title(inputs)
	if (locale === "hi") return hi_shortcut_keys_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_title(inputs)
	return en_shortcut_keys_title(inputs)
});